import type {
  ClientClassificationInput,
  ClientClassificationPreviousAnswer,
  ComponentValueResponse,
  SaveComponentValueResponse,
} from "@repo/shared/types";
import { getWithToken, postWithToken } from "../_client";

const BASE = "/public/flow/client-classification";

export function getPublicClientClassificationValue(token: string) {
  return getWithToken<ComponentValueResponse>(`${BASE}/flow-instance-value`, token);
}

export function savePublicClientClassification(token: string, input: ClientClassificationInput) {
  return postWithToken<SaveComponentValueResponse>(`${BASE}/flow-instance-value`, token, input);
}

export function getPublicClientClassificationPreviousAnswer(token: string) {
  return getWithToken<ClientClassificationPreviousAnswer>(`${BASE}/previous-answer`, token);
}
